import { 
	TOGGLE_SEARCH_STARTED,
	TOGGLE_SEARCH_COMPLETED,
	SET_SEARCH_QUERY
} from '../actions';

const search = (state = { searchStarted: false, searchCompleted: false, searchQuery: '' }, action) => {
	switch (action.type) {
		case SET_SEARCH_QUERY:
			return Object.assign({}, state, {
				searchQuery: action.searchQuery
			});

		case TOGGLE_SEARCH_STARTED:
			let searchStarted = !state.searchStarted;
			return Object.assign({}, state, {
				searchStarted: searchStarted
			});

		case TOGGLE_SEARCH_COMPLETED:
			let searchCompleted = !state.searchCompleted;
			return Object.assign({}, state, {
				searchCompleted: searchCompleted
			});

		default:
			return state;
	}
};

export { search };



/** WEBPACK FOOTER **
 ** ./src/flickr-redux/reducers/searchActionReducers.js
 **/